import boatOutlineImg from '@assets/images/mekkah_icons/boat_outline.svg'
import type { LngLatLike, Map, Marker } from 'mapbox-gl'

import { createMapboxMarker } from './mapbox_helpers'

export class YachtOutline {
  _heading: number = 0
  _map: Map
  _container: HTMLDivElement
  _image: HTMLImageElement
  _marker: Marker
  _onMapRotate: () => void
  _wasAddedToMap: boolean

  constructor (map: Map) {
    this._wasAddedToMap = false

    this._map = map
    this._image = document.createElement('img')
    this._image.className = 'yacht-marker'
    this._image.src = boatOutlineImg

    this._container = document.createElement('div')
    this._container.className = 'yacht-marker-wrapper yacht-marker-wrapper--outline'
    this._container.appendChild(this._image)

    this._marker = createMapboxMarker(this._container)

    this._onMapRotate = () => this.setHeading(this._heading)
  }

  remove () {
    this._marker.remove()

    if (this._map && this._wasAddedToMap) {
      this._map.off('rotate', this._onMapRotate)
    }
  }

  setHeading (heading: number) {
    this._heading = heading
    this._image.style.transform = `rotate(${-heading - this._map.getBearing()}deg)`
  }

  setLatLng (coords: LngLatLike) {
    this._marker.setLngLat(coords)

    if (!this._wasAddedToMap) {
      this._marker.addTo(this._map)
      this._map.on('rotate', this._onMapRotate)
      this._wasAddedToMap = true
    }
  }
}
